var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('nav',{staticClass:"side left compact fixed left-0 top-0 bottom-0 h-full z-30 pointer-events-none"},[_c('div',{staticClass:"text-size8 font-bold font-anonymouse text-light_gray uppercase opacity-100 absolute",attrs:{"id":"mention"}},[_c('span',[_vm._v("AGRICULTURAL CHIC")])])])
}]

export { render, staticRenderFns }